export default __webpack_public_path__ + "static/media/search-icon.7e925f80.svg";